module.exports = __webpack_public_path__ + "img/personal-cabinet.ec9b4080.svg";